import React from 'react';
import EmptyState from './EmptyState.component';
import { Client, Sector, Site } from '@umanforge/common';

interface DataCheckerProps {
  clients?: Client[];
  sites?: Site[];
  sectors?: Sector[];
  children: React.ReactNode;
}

const isInvalid = <T, >( data: T[] | null | undefined ): boolean => {
  return Array.isArray( data ) && data.length === 0;
};

const DataChecker: React.FC<DataCheckerProps> = ( { clients, sites, sectors, children } ) => {

  let render = children;

  if ( isInvalid( sectors ) ) {
    render = <EmptyState type="sectors"/>;
  }
  if ( isInvalid( sites ) ) {
    render = <EmptyState type="sites"/>;
  }
  if ( isInvalid( clients ) ) {
    render = <EmptyState type="clients"/>;
  }

  return render;
};

export default DataChecker;